import { useState } from "react";
import Viewer from "react-viewer";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const PhotoGallery = ({ data, title }) => {
  const { getText } = useLanguageTranslation();
  const imageArray = data.split(",").filter((item) => item !== "");
  const getAlt = (index) =>
    `${title || getText("Power station", "विद्युत स्टेशन")} ${getText(
      "photo",
      "फोटो",
    )} ${index + 1}`;
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img, i) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.trim()}`,
        alt: getAlt(i),
      }))
    );
    setActiveIndex(index);
    setVisible(true);
  };

  return (
    <div className="wow zoomIn">
      <div className="title-sec">
        <h4>{getText("Photo Gallery", "फोटो गैलरी")}</h4>
      </div>
      <div className="row">
        {imageArray.length === 0 ? (
          <div className="col-12 col-sm-12 col-md-4 col-lg-4">
            <p>{getText("Content Awaited", "प्रकरण प्रतीक्षित")}</p>
          </div>
        ) : (
          imageArray.map((item, index) => (
            <div
              key={index}
              className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4"
            >
              <div className="card-sec">
                <div
                  className="img-sec photo-gallery-card"
                  onClick={() => {
                    openViewer(imageArray, index);
                  }}
                >
                  <img
                    alt={getAlt(index)}
                    src={`${process.env.REACT_APP_IMAGE_URL}/${item.trim()}`}
                  />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <div>
        <Viewer
          visible={visible}
          onClose={() => setVisible(false)}
          onMaskClick={() => setVisible(false)}
          images={currentImages}
          activeIndex={activeIndex}
          rotatable={false}
          downloadable={true}
          zoomable={true}
          scalable={false}
          drag={false}
        />
      </div>
    </div>
  );
};

export default PhotoGallery;
